import { useMutation } from '@tanstack/react-query'
import { MainApi } from 'api/MainApi'
import { ICleaningZonePoint, IZone, ZoneUpdateData } from 'utils/interfaces'

interface ReceiveData {
  zone: IZone
  startingPoint: ICleaningZonePoint | undefined
  endingPoint: ICleaningZonePoint | undefined
}

const useEditCleaningZone = () =>
  useMutation<ReceiveData, Error, ZoneUpdateData>({
    mutationFn: MainApi.patchCleaningZone,
  })

export default useEditCleaningZone
